<template>
  <div class="t-calendar-lessons">
    <div class="t-calendar-lesson" v-for="(lesson, index) in lessons_in_week"
         :key="'lesson_' + index"
         :style="'grid-column-start: ' + lesson.grid_column + '; grid-row-start:' + lesson.grid_row_start  + '; grid-row-end:' + lesson.grid_row_end">
      <span class="t-calendar-lesson__time" v-if="lesson.grid_row_end > (lesson.grid_row_start+1)">{{ lesson.time }}</span>
      <span class="t-calendar-lesson__title">{{ lesson.title }}{{ lesson.titleStream }}</span>
      <!--<button class="t-calendar-lesson__del" @click.prevent="Del(lesson.lesson, lesson.date_time)">-->
        <!--<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
          <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M8.00007 1C8.00007 0.447754 7.55231 0 7.00007 0C6.44782 0 6.00007 0.447754 6.00007 1V2H2.00007C1.44782 2 1.00007 2.44775 1.00007 3C1.00007 3.55225 1.44782 4 2.00007 4H7.00007H12.0001C12.5523 4 13.0001 3.55225 13.0001 3C13.0001 2.44775 12.5523 2 12.0001 2H8.00007V1ZM0.531807 5.11646C0.418525 5.17651 0.316475 5.25842 0.23249 5.35925C0.0425488 5.58691 -0.0370411 5.88708 0.0161816 6.17883L0.743232 10.1788L1.47077 14.1788L2.01618 17.1788C2.10261 17.6544 2.51667 18 3.00007 18H11.0001C11.4835 18 11.8975 17.6544 11.984 17.1788L13.2569 10.1788L13.984 6.17883C14.0372 5.88708 13.9576 5.58691 13.7676 5.35925C13.5777 5.13159 13.2965 5 13.0001 5H1.00007C0.835029 5 0.674385 5.04089 0.531807 5.11646ZM2.56208 9L2.19831 7H11.8018L11.4381 9H2.56208ZM3.28913 13L2.92536 11H11.0748L10.711 13H3.28913ZM3.83454 16L3.6529 15H10.3472L10.1656 16H3.83454Z" fill="white"/>-->
        <!--</svg>-->
      <!--</button>-->
    </div>
    <div class="t-calendar-lesson" v-for="(lesson, index) in other_lessons"
         :key="'other_lessons_' + index"
         :style="'grid-column-start: ' + lesson.grid_column + '; grid-row-start:' + lesson.grid_row_start  + '; grid-row-end:' + lesson.grid_row_end">
      <span class="t-calendar-lesson__time" v-if="lesson.grid_row_end > (lesson.grid_row_start+1)">{{ lesson.time }}</span>
      <span class="t-calendar-lesson__title">{{ lesson.title }}</span>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import TimeMixin from '../TimeMixin';
    
    export default {
        mixins: [TimeMixin],
        props: ['lesson_type', 'lessons'],
        computed: {
            ...mapGetters('calendar', ['day_week_header', 'calendarText']),
            ...mapGetters('coursesList', ['streamsMy', 'streamsEntries']),

            lessons_in_week(){
                let les = [];

                for(let i = 0; i < this.lessons.length; i++){
                    for(let j = 0; j < this.lessons[i].date_time.length; j++){
                        let date = new Date(this.lessons[i].date_time[j].date);

                        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                        let month = (parseInt(date.getMonth()) + 1)  < 10 ? '0' + (date.getMonth() + 1): (date.getMonth() + 1);
                        let date_string = date.getFullYear() + '.' + month + '.' + day;

                        if(this.week_arr.indexOf(date_string) >= 0){
                            let index = this.getIndex(date) // берестя из миксина TimeMixin

                            let hours = date.getHours();
                            if(hours < 10)
                                hours = '0' + hours;
                            let minutes = date.getMinutes();
                            if(minutes < 10)
                                minutes = '0' + minutes;

                            let time = hours + ':' + minutes;

                            let title = this.lesson_type === 3 ? (i + 1) + ' ' + this.calendarText.lesson : this.calendarText.lesson;
                            let titleStream = this.lesson_type === 3 ? ', ' + parseInt(j + 1) + ' ' + this.calendarText.stream : '';

                            let grid_row_start = (date.getHours() + 1) * 2;
                            if(date.getMinutes() === 0)
                                grid_row_start--;

                            let grid_row_end = grid_row_start + this.lessons[i].duration.value.minute / 30;

                            minutes = (parseInt(hours) * 60) + parseInt(minutes) + this.lessons[i].duration.value.minute;
                            hours = Math.floor(minutes / 60);
                            minutes = minutes - hours * 60;
                            if(hours < 10)
                                hours = '0' + hours;
                            if(minutes < 10)
                                minutes = '0' + minutes;

                            time += '-' + hours + ':' + minutes;

                            les.push({
                                grid_column: index + 1,
                                grid_row_start: grid_row_start,
                                grid_row_end: grid_row_end,
                                title: title,
                                time: time,
                                lesson: i,
                                date_time: j,
                                titleStream: titleStream
                            });
                        }
                    }
                }

                return les
            },
            other_lessons(){
                let les = [];

                for(let s = 0; s < this.streamsMy.length; s++){
                    let arr = this.Streams(this.streamsMy[s]);

                    les = [...les, ...arr];
                }

                for(let s = 0; s < this.streamsEntries.length; s++){
                    let arr = this.Streams(this.streamsEntries[s]);
                    les = [...les, ...arr];
                }

                return les
            }
        },
        methods: {
            Del(les_index, date_index){
                this.$parent.$parent.lessons[les_index].date_time.splice(date_index, 1);
            },
            Streams(stream){
                let les = [];

                for(let l = 0; l < stream.lessons.length; l++){
                    let lesson = stream.lessons[l];

                    let date = new Date(lesson.date_time);
                    let date_string = date.getFullYear() + '.' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '.' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());

                    if(this.week_arr.indexOf(date_string) >= 0){
                        let index = date.getDay() === 0 ? 7 : date.getDay();

                        let hours = parseInt(date.getHours());
                        let minutes = parseInt(date.getMinutes());

                        let time = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);

                        let grid_row_start = (hours + 1) * 2;
                        if(minutes === 0)
                            grid_row_start--;
                        let grid_row_end = grid_row_start + lesson.duration / 30;

                        minutes = (hours * 60) + minutes + lesson.duration;
                        hours = Math.floor(minutes / 60);
                        minutes = minutes - hours * 60;

                        if(hours < 10)
                            hours = '0' + hours;
                        if(minutes < 10)
                            minutes = '0' + minutes;
                        time += '-' + hours + ':' + minutes;

                        les.push({
                            grid_column: index + 1,
                            grid_row_start: grid_row_start,
                            grid_row_end: grid_row_end,
                            title: stream.name,
                            time: time
                        });
                    }
                }

                return les;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/vue_components/Calendar/Create/Time.vue